import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './user-account-body_types.2';

export function getUserAccountBody(variable?: null, options?: GqlRequestOptions) {
  const query = 'fragment UserAccountBodyValue on UserAccountBodyValue { value label } query GetUserAccountBody { user_account { has_body body { height { ...UserAccountBodyValue } weight { ...UserAccountBodyValue } } } }';
  return gql_request<types.GetUserAccountBody, null>('GetUserAccountBody', query, variable, { use_consumer: true, ...options });
}

